import React , {forwardRef , useEffect, useContext, useState} from 'react';
import styles from './styles.module.css';
// import emoji from '../../objects/emoji.json'
// import emoji from '../../objects/newEmojiCategorized'
import allEmoji from '../../objects/newEmojiCategorized';
import { AdminContext } from '../../context/AdminContext';
import Divider from '../Divider'
import Avatar from '../Avatar';



const Emoji = forwardRef(function (props,ref) {
  let emoji=allEmoji()
  console.log("emoji", emoji)
    const {themeMode}= useContext(AdminContext)
    const [data,setData]= useState(emoji?.[0])
    useEffect(()=>{},[props?.message])
    console.log("message==", props?.message)
    const newMessage=(item)=>{
        let newMessage=props?.message + item
        props?.setMessage(newMessage);
    }
  return (
    <div className={`themeBox ${styles.container} flex flex-col justify-start items-start`} ref={ref}>
                  
          <div className={`flex flex-row justify-start items-start w-auto h-auto ${styles.head} ${themeMode=="dark" && styles.dark}`}>
          {emoji?.map((item,index)=>(
            <div key={index} onClick={()=>{setData(item)}} className={`${item?.slug==data.slug ? `${styles.activeTab} ${themeMode=="dark" && 'makeWhite'}` : styles.unActiveTab}`}>{item?.icon}</div>
            ))}
            </div>
            <Divider/>    
    <div className={` flex flex-row justify-start items-start ${styles.iconContainer} ${themeMode=="dark" && styles.dark} h-auto`} >
        {/* {emoji?.map((item,index)=>(
            <span key={index} onClick={()=>{newMessage(item)}}>{item}</span>
        ))} */}
            <div className={`flex flex-row justify-start items-start w-full h-auto flex-wrap h-auto`}>
            {data?.emojis?.map((i,j)=>(
            <span key={j} onClick={()=>{newMessage(i?.emoji)}}>{i?.emoji}</span>
            ))}
            </div>
    </div>
    <div className={styles.space}></div>
    </div>
  )
})
export default Emoji;